import useApiMutation from 'shared/hooks/use-api-mutation';
import {OrderProps} from '../types';
import useUpdateOrder from '../util/use-update-orders';

const useAssignOrder = (orderId: string) => {
  const updateOrder = useUpdateOrder();

  const onSuccess = (data: OrderProps) =>
    updateOrder(data, data.currentStatusName);

  return useApiMutation({
    url: `/orders/${orderId}/assign`,
    method: 'PATCH',
    errorTitle: 'Erro ao vincular pedido',
    successTitle: 'Alteração de status do pedido',
    successMessage: 'Pedido vinculado ao entregador!',
    onSuccess,
  });
};

export default useAssignOrder;
